export function getLabelSizeFromSku(sku: string): string {
  return sku?.split('-')?.[0] ?? ''
}
